import routerOptions0 from "/builds/kampaay/scrum/node_modules/.pnpm/nuxt@3.14.159_@parcel+watcher@2.5.0_@types+node@18.19.64_ioredis@5.4.1_magicast@0.3.5_rollup@_p5ugzijmgl2a4yb6ff4niyfgw4/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}